class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    this.giftWrapClickHandler = (event) => {
      const containerDetailsGift = document.getElementById(
        "Details-Gift-Wrapping"
      );
      this.giftWrapHandleCustom(containerDetailsGift, event);
    };
    this.initializeGiftWrappingToggle();
  }

  giftWrapHandleCustom(containerDetailsGift, event) {
    const buttonDetailsGift = event.target.closest("button");

    if (buttonDetailsGift && containerDetailsGift.contains(buttonDetailsGift)) {
      const contentDetailsGift = document.getElementById(
        buttonDetailsGift.getAttribute("aria-controls")
      );

      if (contentDetailsGift) {
        const isExpanded =
          buttonDetailsGift.getAttribute("aria-expanded") === "true";
        buttonDetailsGift.setAttribute(
          "aria-expanded",
          isExpanded ? "false" : "true"
        );
        contentDetailsGift.style.display = isExpanded ? "none" : "block";
        containerDetailsGift.classList.toggle("expanded", !isExpanded);
      }
    }
  }

  initializeGiftWrappingToggle() {
    const containerDetailsGift = document.getElementById(
      "Details-Gift-Wrapping"
    );

    if (containerDetailsGift) {
      containerDetailsGift.addEventListener("click", this.giftWrapClickHandler);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    let mobileMenu = document.querySelector("fostr-mobilemenu");
    if (mobileMenu) {
      if (mobileMenu.classList.contains("mobilemenu--isVisible")) {
        mobileMenu.mobilemenuHide();
      }
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    let quickBuy = document.querySelector("gdl-quick-shop-modal-dialog[open]");
    if (quickBuy) {
      quickBuy.hide();
    }
    // this.initializeGiftWrappingToggle();

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document
      .querySelector("#CartDrawer .drawer__inner")
      .classList.remove("prevent");
    removeTrapFocus(this.activeElement);

    const containerDetailsGift = document.getElementById(
      "Details-Gift-Wrapping"
    );

    if (containerDetailsGift) {
      containerDetailsGift.removeEventListener(
        "click",
        this.giftWrapClickHandler
      );
    }
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");

    document
      .querySelector("cart-drawer .message-content")
      .classList.remove("open");
    document
      .querySelector("cart-drawer .message-drawer")
      .classList.remove("active");

    document
      .querySelector("cart-drawer .giftwrap-content")
      .classList.remove("open");
    document
      .querySelector("cart-drawer .giftwrap-drawer")
      .classList.remove("active");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

//customElements.define('cart-drawer-items', CartDrawerItems);
